import React from "react";
import { motion } from "framer-motion";

const Navbar = () => {
  return (
    <div className="flex items-center pt-6 mb-6 justify-center w-full z-50 relative">
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
        className="text-center p-4"
      >
        <div className="rpg-title-text text-2xl md:text-4xl">
           RUCOY HELPER
        </div>
      </motion.div>
    </div>
  );
};

export default Navbar;